import React, { useState } from 'react';
import './CardGallery.css';

function CardGallery({ groups, variant = 'card' }) {
  const [groupIndex, setGroupIndex] = useState(0);
  const [cardIndex, setCardIndex] = useState(0);

  const currentGroup = groups[groupIndex];
  const currentCard = currentGroup.cards[cardIndex];

  const prevCard = () => {
    if (cardIndex > 0) {
      setCardIndex(cardIndex - 1);
    } else if (groupIndex > 0) {
      const prevGroup = groups[groupIndex - 1];
      setGroupIndex(groupIndex - 1);
      setCardIndex(prevGroup.cards.length - 1);
    }
  };

  const nextCard = () => {
    if (cardIndex < currentGroup.cards.length - 1) {
      setCardIndex(cardIndex + 1);
    } else if (groupIndex < groups.length - 1) {
      setGroupIndex(groupIndex + 1);
      setCardIndex(0);
    }
  };

  const isFirst = groupIndex === 0 && cardIndex === 0;
  const isLast = groupIndex === groups.length - 1 && 
                 cardIndex === currentGroup.cards.length - 1;

  return (
    <div className={`card-gallery ${variant}`}>
      <div className="card-gallery-header">
        <span className="group-name">{currentGroup.name}</span>
        <span className="card-counter">
          {cardIndex + 1} / {currentGroup.cards.length}
        </span>
      </div>

      <div className="card-gallery-viewer">
        <button
          className="arrow"
          onClick={prevCard}
          disabled={isFirst}
          aria-label="Previous card"
        >
          ↤
        </button>

        <div className={`card-display ${variant}`}>
          <img src={currentCard.src} alt={currentCard.label} />
          <span className="card-label">{currentCard.label}</span>
        </div>

        <button
          className="arrow"
          onClick={nextCard}
          disabled={isLast}
          aria-label="Next card"
        >
          ↦
        </button>
      </div>

      {groups.length > 1 && (
        <div className="group-dots">
          {groups.map((group, i) => (
            <button
              key={group.name}
              className={`group-dot ${i === groupIndex ? 'active' : ''}`}
              onClick={() => { setGroupIndex(i); setCardIndex(0); }}
              aria-label={group.name}
              title={group.name}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default CardGallery;